import { render, staticRenderFns } from "./SpiderwebChart.vue?vue&type=template&id=0a61ed1e&scoped=true&"
import script from "./SpiderwebChart.vue?vue&type=script&lang=js&"
export * from "./SpiderwebChart.vue?vue&type=script&lang=js&"
import style0 from "./SpiderwebChart.vue?vue&type=style&index=0&id=0a61ed1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a61ed1e",
  null
  
)

export default component.exports